import { useWidgets } from "../context/WidgetContext";
import { FloatingWidget } from "./FloatingWidget";
import { WIDGET_RENDERERS } from "./widgets";

export function WidgetLayer() {
  const { widgets } = useWidgets();

  const minimized = widgets.filter((w) => w.minimized);
  const visible = widgets.filter((w) => !w.minimized);

  return (
    <>
      {/* Active widgets */}
      {visible.map((widget) => {
        const Renderer = WIDGET_RENDERERS[widget.type] ?? WIDGET_RENDERERS["generic"];
        return (
          <FloatingWidget
            key={widget.id}
            id={widget.id}
            title={widget.title}
            widgetType={widget.type}
            data={widget.data}
            position={widget.position}
            size={widget.size}
            minimized={false}
            zIndex={widget.zIndex}
          >
            <Renderer data={widget.data} />
          </FloatingWidget>
        );
      })}

      {/* Minimized widget bar at bottom */}
      {minimized.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 flex gap-1 px-2 z-[9999] pointer-events-none">
          {minimized.map((widget) => (
            <div key={widget.id} className="pointer-events-auto">
              <FloatingWidget
                id={widget.id}
                title={widget.title}
                position={widget.position}
                size={widget.size}
                minimized={true}
                zIndex={widget.zIndex}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
